import { render, staticRenderFns } from "./SupplierQualityForm.vue?vue&type=template&id=6a233071&scoped=true"
import script from "./SupplierQualityForm.vue?vue&type=script&lang=js"
export * from "./SupplierQualityForm.vue?vue&type=script&lang=js"
import style0 from "./SupplierQualityForm.vue?vue&type=style&index=0&id=6a233071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a233071",
  null
  
)

export default component.exports